import type { ReactNode } from "react";

import clsx from "clsx";
import { RadioGroup } from "react-aria-components";
import { useController, useFormContext } from "react-hook-form";

import styles from "./radio-input.module.css";

type RadioInputProps = {
	ariaLabel: string;
	children: ReactNode;
	className?: string;
	isDisabled?: boolean;
	name: string;
	onChange?: (value: string) => void;
};

export function RadioInput({
	ariaLabel,
	children,
	className,
	isDisabled,
	name,
	onChange,
}: RadioInputProps): ReactNode {
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, disabled: isDisabled, name });

	return (
		<RadioGroup
			aria-label={ariaLabel}
			className={clsx(styles.group, className)}
			isDisabled={field.disabled}
			isInvalid={fieldState.invalid}
			name={field.name}
			onBlur={field.onBlur}
			onChange={(v) => {
				field.onChange(v);
				onChange?.(v);
			}}
			ref={field.ref}
			value={field.value as string}
		>
			{children}
			{fieldState.invalid ? (
				<span className={clsx("caption", styles.errorMessage)}>
					{fieldState.error?.message}
				</span>
			) : null}
		</RadioGroup>
	);
}
